import { ApiParameter, patch } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface DeleteShipToParameter extends ApiParameter {
    shipToId: string;
}

export interface DeleteShipParmsModel extends BaseModel {
    shipToId: string;
}

const deleteShipToUrl = "/api/v2/deactivateshipto";

export function deleteShipTo(parameter: DeleteShipToParameter) {
    const { shipToId } = parameter;
    const requestBody = { shipToId };
    return patch<DeleteShipParmsModel>(`${deleteShipToUrl}/${shipToId}`, requestBody);
}
